import { createFileRoute, Outlet } from '@tanstack/react-router';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { darkTheme } from '@repo/theme';
import { getDefaultExperience } from 'src/api/authentication';
import { hardRedirect } from 'src/utils/hardRedirect';
export const Route = createFileRoute('/authentication')({
	beforeLoad: async () => {
		// Runs for every authentication route (including /authentication/login).
		// When the 2.0 experience is the default, send users to the new auth app.
		const experience = await getDefaultExperience();
		if (experience === '2.0') {
			await hardRedirect('/app/auth/?ssoError=false');
		}
	},
	component: AuthenticationLayout,
});

function AuthenticationLayout() {
	return (
		<ThemeProvider theme={darkTheme}>
			<CssBaseline />
			<Outlet />
		</ThemeProvider>
	);
}
